import { AbstractModalService } from '@/core/modals/AbstractModalService';
import { ModalOptions } from '@/core/modals/ModalState';
import { UrlQueryKey } from '@/core/urlQueryKey';

class SearchPageBrandProductGuideOverlayService extends AbstractModalService {
    public show(content, options?: Partial<ModalOptions>): Promise<{ guide: { [UrlQueryKey.productGuideBrandName]: string, [UrlQueryKey.productGuideId]?:string, [UrlQueryKey.productGuideKey]?: string, productGuideUrl: string } }> {
        return this.showModal({
            component: () => import(
                /* webpackChunkName: 'brandProductGuideOverlay' */
                '@/project/app/blocks/productguide/StepProductGuide/Overlay/BrandProductGuidePLPOverlayWrapper.vue'),
            componentAttrs: {
                content
            },
            options: {
                placement: 'right',
                modalClass: 'mr-0 mt-0 mb-0',
                closeButtonPosition: 'right-30',
                contentMaxHeight: false,
                disableBodyScroll: true,
                usePanelWrapper: false,
                closeOnBreakpointChange: false,
                ...options
            }
        });
    }
}

export default new SearchPageBrandProductGuideOverlayService();
